export default __webpack_public_path__ + "static/media/group50097.88e4001f.png";